import Route from 'cio/routes/base';
import { inject as service } from '@ember/service';
import { action } from '@ember/object';

export default class NewRoute extends Route {
  @service analytics;
  @service auth;
  @service router;

  crumb() {
    return {
      name: 'New',
      path: 'broadcasts.new',
    };
  }

  beforeModel(transition) {
    super.beforeModel(transition);
    if (Boolean(this.auth.hasPermission('journeys/broadcasts/create')) === false) {
      return this.router.transitionTo('broadcasts.list.newsletters.index');
    }
    return;
  }

  setupController(controller) {
    super.setupController(...arguments);
    controller.setDefaults();
  }

  resetController(controller) {
    super.resetController(...arguments);
    controller.setDefaults();
  }

  @action
  didTransition() {
    this.analytics.track('broadcast', 'create_started');
    return true;
  }
}
